import {NgModule} from '@angular/core';
import {AsyncPipe, CommonModule} from '@angular/common';
import {LorenImagePipe} from './pipes/loren-image.pipe';


@NgModule({
    declarations: [
        LorenImagePipe
    ],
    exports: [
        LorenImagePipe
    ],
    providers: [
        AsyncPipe
    ],
    imports: [
        CommonModule
    ]
})
export class LorenImageModule { }
